/**
 * Self-referencing hreflang annotations.
 *
 * The site is single-language (English, India). Google still expects a
 * self-referencing `hreflang` plus an `x-default` fallback pointing at the
 * same URL, so shared-link and SERP handling stays unambiguous.
 *
 * Always pass the canonical (non-www) absolute path so hreflang and canonical
 * agree — a mismatch makes crawlers discard both.
 */
const ORIGIN = "https://arifkhanglobal.com";

export function hreflangLinks(path: string) {
  const href = path.startsWith("http") ? path : `${ORIGIN}${path}`;
  return [
    { rel: "alternate", hrefLang: "en", href },
    { rel: "alternate", hrefLang: "x-default", href },
  ];
}
